import React, { useEffect, useState } from 'react';

import { Button, Checkbox } from '@components/common';
import Attributes from '@components/ExportRules/Attributes';

import { TExportAssetsRulesDTO } from '@interfaces/assets/dto/assetsDTO';

import { RulesCheckboxesData } from '@constants/common';

import styles from './ExportRules.module.scss';

interface IExportRulesParams {
	rules: TExportAssetsRulesDTO;
	setRules: React.Dispatch<React.SetStateAction<TExportAssetsRulesDTO>>;
	isLoadingForm: boolean;
	updateSubmitHandler: (dto: TExportAssetsRulesDTO) => void;
	helperText: string;
	type: string;
}

const ExportRules = ({
	isLoadingForm,
	helperText,
	updateSubmitHandler,
	rules,
	type,
	setRules,
}: IExportRulesParams) => {
	const [isCheckedMainCheckbox, setIsCheckedMainCheckbox] = useState(false);

	const onSubmit = () => updateSubmitHandler({
		...rules,
		type,
	});

	const onChange = (checked: boolean, name: string) => {
		setRules((prev: TExportAssetsRulesDTO) => {
			return {
				...prev,
				[name]: checked,
			};
		});
	};

	const onCheckAllCheckboxes = (checked: boolean, _name: string) => {
		setIsCheckedMainCheckbox(checked);

		const prepareRules = { ...rules } as any;

		for (const key in prepareRules) {
			prepareRules[key] = checked;
		}

		setRules(prepareRules);
	};

	useEffect(() => {
		const prepareRules = rules as any;

		for (const key in prepareRules) {
			if (typeof prepareRules[key] === 'boolean' && !prepareRules[key]) {
				setIsCheckedMainCheckbox(false);
				return;
			}
		}

		setIsCheckedMainCheckbox(true);
	}, [rules]);

	return (
		<div>
			<div className={styles.rulesContainer}>
				<div className={styles.helperText}>
					{helperText}
				</div>
				<Checkbox
					checked={isCheckedMainCheckbox}
					disabled={isLoadingForm}
					label='Select all'
					name='selectAll'
					onChange={onCheckAllCheckboxes}
				/>
				<div className={styles.basicInfo}>
					<p className={styles.containersHeaderText}>Basic Information</p>
					<div className={styles.basicInfoCheckboxes}>
						{
							RulesCheckboxesData.basicInfo.map((checkbox) => {
								const checkboxRules = rules as any;

								return (
									<Checkbox
										key={checkbox.name}
										checked={checkboxRules[checkbox.name]}
										disabled={isLoadingForm}
										label={checkbox.label}
										name={checkbox.name}
										onChange={onChange}
									/>
								);
							})
						}
					</div>
				</div>
				<div>
					<p className={styles.containersHeaderText}>Address</p>
					<div className={styles.basicInfoCheckboxes}>
						{
							RulesCheckboxesData.address.map((checkbox) => {
								const checkboxRules = rules as any;

								return (
									<Checkbox
										key={checkbox.name}
										checked={checkboxRules[checkbox.name]}
										disabled={isLoadingForm}
										label={checkbox.label}
										name={checkbox.name}
										onChange={onChange}
									/>
								);
							})
						}
					</div>
				</div>
				<div>
					<p className={styles.containersHeaderText}>Attributes</p>
					{
						RulesCheckboxesData.attributes.map((checkboxData) => {
							return (
								<Attributes
									key={checkboxData.nameStatus}
									checkboxData={checkboxData}
									isLoadingForm={isLoadingForm}
									onChange={onChange}
									rules={rules}
								/>
							);
						})
					}
				</div>
			</div>
			<div className={styles.submitButtons}>
				<Button
					disabled={isLoadingForm}
					onClick={onSubmit}
					text='Save'
				/>
			</div>
		</div>
	);
};

export default ExportRules;
